import { render, staticRenderFns } from "./DetailLayout.vue?vue&type=template&id=0abd0bb1&"
import script from "./DetailLayout.vue?vue&type=script&lang=ts&"
export * from "./DetailLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports